import { axios, API_V2, backEndAxios } from '../../../../services/httpClient';
import _ from 'lodash';

export const updateToMasterUser = (id) => {
	return backEndAxios.put(`/centralBackend/${API_V2}/iam/updateToMasterUser`, { userId: id });
};
